export default "__VITE_ASSET__BeWJqgqk__"